import { useGetMySummary } from "@/api/user/useGetMySummary";
import { Center, Loader } from "@mantine/core";
import { EditUserProfileForm } from "./EditUserProfileForm";

export function EditUserProfileLoader() {
  const { data: user, isLoading } = useGetMySummary();

  if (isLoading || !user) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  return <EditUserProfileForm user={user} />;
}
